(() => {
  // Ensemble de pourcentages à remplacer
  const REPLACEMENTS = [
    { re: /(Économisez|Save)[\s\u00A0]*5[.,]?0?[\s\u00A0]*%/i,  fr: 'Économisez 18,8\u00A0% — soit le prix d’une box', en: 'Save 18.8% — equal to one free box' },
    { re: /(Économisez|Save)[\s\u00A0]*6[.,]?67[\s\u00A0]*%/i,  fr: 'Économisez 20\u00A0% — soit le prix d’une box',   en: 'Save 20% — equal to one free box' },
    { re: /(Économisez|Save)[\s\u00A0]*8[.,]?33[\s\u00A0]*%/i,  fr: 'Économisez 21,5\u00A0% — soit le prix d’une box', en: 'Save 21.5% — equal to one free box' },
    { re: /(Économisez|Save)[\s\u00A0]*17[\s\u00A0]*%/i,        fr: 'Économisez 17\u00A0% — soit le prix d’une box',   en: 'Save 17% — equal to one free box' },
    { re: /(Économisez|Save)[\s\u00A0]*20[\s\u00A0]*%/i,        fr: 'Économisez 20\u00A0% — soit le prix d’une box',   en: 'Save 20% — equal to one free box' },
    { re: /(Économisez|Save)[\s\u00A0]*21[.,]?5[\s\u00A0]*%/i,  fr: 'Économisez 21,5\u00A0% — soit le prix d’une box', en: 'Save 21.5% — equal to one free box' },
  ];

  const replaceIn = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    let node;
    while ((node = walker.nextNode())) {
      const raw = node.textContent.trim();
      for (const { re, fr, en } of REPLACEMENTS) {
        if (re.test(raw)) {
          const isEnglish = /^save/i.test(raw);
          node.textContent = isEnglish ? en : fr;
          break;
        }
      }
    }
  };

  // Rafraîchit quand Seal modifie le DOM
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      replaceIn(document.body);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => replaceIn(document.body));
  } else {
    replaceIn(document.body);
  }

  const mo = new MutationObserver(() => schedule());
  mo.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
})();